import realisticImg from '../assets/render_style/Realistic.webp';
import sketchImg from '../assets/render_style/Sketch.webp';
import handImg from '../assets/render_style/Hand.webp';
import pencil3dImg from '../assets/render_style/Pencile-3D.webp';
import animeImg from '../assets/render_style/Anmi.webp';
import markerImg from '../assets/render_style/Marker.webp';

export const FLOOR_PLAN_3D_OUTPUT_TYPE_DEFAULT = 'open-top-3d';

export const FLOOR_PLAN_3D_OUTPUT_TYPE_OPTIONS = [
  {
    value: 'open-top-3d',
    label: 'Realistic',
    cardLabel: 'Realistic',
    image: realisticImg,
  },
  {
    value: 'sketch',
    label: 'Sketch',
    cardLabel: 'Sketch',
    image: sketchImg,
  },
  {
    value: 'hand-drawing',
    label: 'Hand Drawing',
    cardLabel: 'Hand Drawing',
    image: handImg,
  },
  {
    value: 'pencil-outline-3d',
    label: 'Pencil-3D',
    cardLabel: 'Pencil-3D',
    image: pencil3dImg,
  },
  {
    value: 'anime-style',
    label: 'Anime Style',
    cardLabel: 'Anime Style',
    image: animeImg,
  },
  {
    value: 'marker-pen-style',
    label: 'Marker Pen Style',
    cardLabel: 'Marker Pen Style',
    image: markerImg,
  },
];
